import { Dropdown, DropdownMenuItemProps } from '../../Dropdown';
import { IconButton } from '../../IconButton';
import { Icons } from '../../Icons';
import { RowHeightView } from '../types';

interface TableViewMenuProps {
  rowHeightView: RowHeightView;
  setRowHeightView: (value: RowHeightView) => void;
}

export function TableViewMenu({
  rowHeightView,
  setRowHeightView,
}: TableViewMenuProps) {
  const createViewMenuItems = (): DropdownMenuItemProps[] => {
    return [
      {
        label: 'Increase row height',
        icon: Icons.Rows02,
        onClick: () => setRowHeightView('expanded'),
        className: rowHeightView === 'expanded' ? 'bg-bg-secondary' : '',
        shortcut:
          rowHeightView === 'expanded' ? (
            <Icons.Check className="size-4 text-fg-brand" />
          ) : undefined,
      },
      {
        label: 'Decrease row height',
        icon: Icons.Rows03,
        onClick: () => setRowHeightView('regular'),
        className: rowHeightView === 'regular' ? 'bg-bg-secondary' : '',
        shortcut:
          rowHeightView === 'regular' ? (
            <Icons.Check className="size-4 text-fg-brand" />
          ) : undefined,
      },
    ];
  };

  const menu = {
    groups: [
      {
        items: createViewMenuItems(),
      },
    ],
  };

  return (
    <Dropdown
      menu={menu}
      align="end"
      contentClassName="w-48"
      side="bottom"
      sideOffset={8}
    >
      <IconButton
        icon={<Icons.DotsHorizontal className="size-4" />}
        aria-label="Table view options"
        size="lg"
      />
    </Dropdown>
  );
}
